<template>

    <CobaltDashboard :info="null" :company="null" :withFilterBar="false" contentClasses="single ps-0">

        <div>
            <div class="home row">
                <div class="col-lg-2">
                    <div class="dashboard-panel h-100">
                        <div class="dashboard-panel__body">
                            <h3 class="dashboard-panel__title">{{ $t("UI.settings.baseSettings") }}</h3>
                            <ul class="nav nav-pills cobalt-vertical-tabs flex-column" id="myTab" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link active" id="files-tab" data-bs-toggle="tab" data-bs-target="#settings-profile" type="link" role="tab" aria-controls="home" aria-selected="true">
                                        <img src="@/assets/images/dashboard/base-profile-dark.svg"> {{ $t("UI.settings.profile") }}
                                    </button>
                                </li>

                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="files-tab" data-bs-toggle="tab" data-bs-target="#settings-security" type="button" role="tab" aria-controls="home" aria-selected="true">
                                        <img src="@/assets/images/dashboard/base-lock-dark.svg"> {{ $t("UI.settings.security") }}
                                    </button>
                                </li>

                                <li class="nav-item" role="presentation">
                                    <button disabled class="nav-link" id="comments-tab" data-bs-toggle="tab" data-bs-target="#comments" type="button" role="tab" aria-controls="home" aria-selected="true">
                                        <img src="@/assets/images/dashboard/base-notification-dark.svg"> {{ $t("UI.settings.notifications") }}
                                    </button>
                                </li>                

                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="design-tab" data-bs-toggle="tab" data-bs-target="#settings-design" type="button" role="tab" aria-controls="home" aria-selected="true">
                                        <img src="@/assets/images/dashboard/base-design-dark.svg"> {{ $t("UI.settings.design") }}
                                    </button>
                                </li>                                                
                            </ul>                            
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="tab-content" id="settings-tabContent">
                      
                        <div class="tab-pane fade show active" id="settings-profile" role="tabpanel" aria-labelledby="settings-profile-tab">
                            <div class="dashboard-panel">
                                <div class="dashboard-panel__body">                            
                                    <h3 class="dashboard-panel__title">Профиль {{ user?.username }}</h3>
                                    <div class="dashboard-panel__plaintext mt-4 ">
                                        Настройки Вашего профиля, настройки видимости полей осуществляются на странице "Безопасность"
                                    </div>
                                    <div class="settings-single-row mt-4">
                                        <a class="setting-profile__avatar nav-link" href="#" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            MP
                                        </a>
                                    </div>

                                    <div class="settings-single-row mt-4 mb-3">
                                        <div class="cobalt-form-group">
                                            <label for="basic-url" class="form-label">{{ $t('auth.firstname') }}</label>
                                            <div class="input-group">
                                                <input type="text" class="form-control" v-model="user.first_name">
                                            </div>
                                        </div>  
                                    </div>   

                                    <div class="settings-single-row mb-3">
                                        <div class="cobalt-form-group">
                                            <label for="basic-url" class="form-label">{{ $t('auth.surname') }}</label>
                                            <div class="input-group">
                                                <input type="text" class="form-control" v-model="user.last_name">
                                            </div>
                                        </div>  
                                    </div>                                     

                                    <div class="settings-single-row mb-3">
                                        <div class="cobalt-form-group">
                                            <label for="basic-url" class="form-label">{{ $t('UI.settings.about') }}</label>
                                            <div class="input-group">
                                                <textarea class="form-control" id="basic-url" aria-describedby="basic-addon3"></textarea>
                                            </div>
                                        </div>  
                                    </div>  

                                    <div class="settings-single-row mb-3">
                                        <div class="row">
                                            <div class="cobalt-form-group col-lg-8">
                                                <label for="basic-url" class="form-label">{{ $t('UI.settings.email') }}</label>
                                                <div class="input-group">
                                                    <input type="text" class="form-control" v-model="user.mail" disabled>
                                                </div>
                                            </div>  

                                            <div class="cobalt-form-group col-lg-4">
                                                <label for="basic-url" class="form-label">{{ $t('UI.settings.language') }}</label>
                                                <div class="input-group">
                                                    <select class="form-control" v-model="user.lang">
                                                        <option value="ru">RU</option>
                                                        <option value="en">EN</option>
                                                    </select>
                                                </div>
                                            </div>         
                                        </div>                                 
                                    </div>  
                                </div>
                                <div class="dashboard-panel__footer mt-4">
                                    <button class="btn cobalt-blue-button" @click="doSaveSettings" :disabled="this.isLoading">
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="this.isLoading"></span>
                                        {{ $t("UI.save") }}
                                    </button>                            
                                </div>                                
                            </div>
                        </div>
                        <div class="tab-pane fade" id="settings-security" role="tabpanel" aria-labelledby="settings-security-tab">
                            <div class="dashboard-panel">
                                <div class="dashboard-panel__body">                                   
                                    <h3 class="dashboard-panel__title">{{ $t("UI.settings.authentication")}}</h3>

                                    <div class="settings-single-row mt-4 mb-3">
                                        <div class="cobalt-form-group">
                                            <label for="basic-url" class="form-label">{{ $t('UI.settings.oldPassword') }}</label>
                                            <div class="input-group">
                                                <input type="text" class="form-control" v-model="password.old">
                                            </div>
                                        </div>  
                                    </div>   

                                    <div class="settings-single-row mb-3">
                                        <div class="cobalt-form-group">
                                            <label for="basic-url" class="form-label">{{ $t('UI.settings.newPassword') }}</label>
                                            <div class="input-group">
                                                <input type="text" class="form-control" v-model="password.new">
                                            </div>
                                        </div>  
                                    </div>                                     

                                    <div class="settings-single-row mb-3">
                                        <div class="cobalt-form-group">
                                            <label for="basic-url" class="form-label">{{ $t('UI.settings.newPasswordRetype') }}</label>
                                            <div class="input-group">
                                                <input type="text" class="form-control" v-model="password.new2">
                                            </div>
                                        </div>  
                                    </div> 
                                    <div class="settings-single-rows">
                                        <p class="error_text" v-if="this.errorText">{{  this.errorText }}</p>
                                    </div> 
                                </div>    
                                <div class="dashboard-panel__footer mt-4">
                                    <button class="btn cobalt-blue-button" @click="doChangePassword" :disabled="this.isLoading">
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="this.isLoading"></span>
                                        {{ $t("UI.save") }}
                                    </button>                            
                                </div>                                    
                            </div>                                            
                        </div>
                        <div class="tab-pane fade" id="settings-design" role="tabpanel" aria-labelledby="settings-design-tab">
                            <div class="dashboard-panel">
                                <div class="dashboard-panel__body">                                   
                                    <h3 class="dashboard-panel__title">{{ $t("UI.settings.design")}}</h3>

                                    <div class="settings-single-row mt-4 mb-3">
                                        <div class="cobalt-form-group">
                                            <div class="form-check form-switch">
                                                <label class="form-check-label" for="flexSwitchCheckDefault">Hide covers in projects</label>
                                                <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault">
                                            </div>
                                        </div>  
                                    </div>   

                                    <div class="settings-single-row mb-3">
                                        <div class="cobalt-form-group">
                                            <label for="basic-url" class="form-label">Day starts from</label>
                                            <div class="input-group">
                                                <input type="text" class="form-control" id="basic-url" aria-describedby="basic-addon3">
                                            </div>
                                        </div>  
                                    </div>                                     

                                    <div class="settings-single-row mb-3">
                                        <div class="cobalt-form-group">
                                            <label for="basic-url" class="form-label">Day end in</label>
                                            <div class="input-group">
                                                <input type="text" class="form-control" id="basic-url" aria-describedby="basic-addon3">
                                            </div>
                                        </div>  
                                    </div>  
                                </div>    
                                <div class="dashboard-panel__footer mt-4">
                                    <button class="btn cobalt-blue-button">{{ $t("UI.save") }}</button>                            
                                </div>                                    
                            </div>                                            
                        </div>
                    </div>                
                </div>
            </div>
        </div>

    </CobaltDashboard>

</template>

<script>

import CobaltDashboard from "@/components/dashboard/CobaltDashboard.vue"
import { createToast } from 'mosha-vue-toastify'   
import { mapGetters, mapActions } from 'vuex'
import { DatePicker } from "qalendar"
import Config from '../config.js'
import "qalendar/dist/style.css"

export default {
    components: {
        CobaltDashboard,
        DatePicker
    },
    data() {
        return {
            Config,
            isLoading: false,
            user: {
                first_name: '',
                last_name: '',
                about: '',
                lang: ''
            },
            password: {
                old: '',
                new: '',
                new2: ''
            },
            errorText: ''
        }
    },
    beforeMount: function () {
        this.getUserInfo()
    },

    methods: {
        ...mapActions('company', ['list', 'addCompany', 'delete']),
        ...mapGetters('company', ['getList']), 
        ...mapActions('user', ['userInfo', 'saveSettings', 'changePassword']),

        async getUserInfo() {
            this.user = await this.userInfo()            
        },
        async doSaveSettings() {
            this.isLoading = true
            
            const res = await this.saveSettings(this.user)
            if (res) {
                createToast({ description: this.$t("UI.settings.saved") }, {
                    hideProgressBar: true,
                    timeout: 1000,
                    position: 'bottom-center',
                    transition: 'slide',
                    showIcon: false,
                    showCloseButton: false,
                    swipeClose: false,
                })                
            }

            this.isLoading = false  
        },
        async doChangePassword() {
            this.isLoading = true
            
            const res = await this.changePassword(this.password)
            if (res.status != 400) {
                this.password = { old: '', new: '', new2: '' }

                createToast({ description: this.$t("UI.settings.saved") }, {
                    hideProgressBar: true,
                    timeout: 1000,
                    position: 'bottom-center',
                    transition: 'slide',
                    showIcon: false,
                    showCloseButton: false,
                    swipeClose: false,
                })                
                this.errorText = ''
            } else {
                this.errorText = this.$t("error.code" + res.code)
            }

            this.isLoading = false                        
        }

    }

}
</script>

<style>
    .home {
        width: 100%;
        height: 100%;
    }
    .welcome-block {
        position: relative;
        display: flex;
        align-items: center;        
        border-radius: 8px;
        color: #FFF;
        background-color: rgb(34,193,195);
        background-image: url("../../src/assets/images/dashboard/home/bg.png") no-repeat right top;        
        background: url("../../src/assets/images/dashboard/home/bg.png") no-repeat right top, linear-gradient(155deg, rgba(34,193,195,1) 0%, rgba(20,41,65,1) 100%);
        margin-top: 35px;
    }
    .welcome-block img {
        margin-top: -25px;
    }
    .welcome-panel {
        background-color: #e8f2fd;
        border-radius: 8px;
        margin-top: 25px;
        padding: 15px;
    }
    .welcome-panel.transparent {
        background-color: transparent;
    }
    .welcome-panel__header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
    }
    .welcome-panel__header-header {
        font-weight: 600;
        font-size: 18px;
    }    
    .date-picker.date-picker-root {
        width: auto;
    } 
    .date-picker .week span {
        border-radius: 8px;
    }    
    .date-picker.date-picker-root .week span.is-weekend {
        color: #F44336;
    }    
    .date-picker-root .date-picker__week-picker:not(.is-light-mode .date-picker__week-picker) {
        background-color: #ffffff;
        border-color: transparent;
        box-shadow: none;
        padding: 0;
    }
    .date-picker__week-picker-navigation {
        font-weight: 500 !important;
        text-transform: uppercase;
        border-bottom: 1px solid #ededed;
        padding: 20px 0;
        position: relative;
    }
    .date-picker__toggle-mode {
        position: absolute;
        left: 0;
    }
    svg.svg-inline--fa.fa-circle-chevron-left.is-icon.is-chevron-left {
        position: absolute;
        right: 32px;
    }
    svg.svg-inline--fa.fa-circle-chevron-right.is-icon.is-chevron-right {
        position: absolute;
        right: 0;
    }  
    .date-picker .week span {
        border-radius: 10px !important;
    }    
    .progress-bar {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background: 
            radial-gradient(closest-side, #e8f2fd 92%, transparent 95% 100%),
            conic-gradient(rgb(34,193,195) 75%, rgb(255, 255, 255) 0);    
    }
    .progress-bar::before {
        content: "75%";
    }
    .single-project,
    .single-activity {
        display: flex;
        border: 1px solid #c9d9e9;
        border-radius: 8px;
        margin-bottom: 10px;
        padding: 10px 20px;
        align-items: center;
    }  
    .single-project__name {
        padding-left: 15px;
        flex:1;
    }   
    .single-project__name h3 {
        margin: 0;
        font-size: 16px;
    }
    .days-left {
        padding: 7px 15px;
        background-color: #1b7280;
        color: #FFF;
        border-radius: 8px;
        font-size: 12px;
    }
    .single-activity {
        background-color: #e8f2fd;
        border: none;
    }
    .single-activity__name h3 {
        padding-top: 5px;
        font-size: 16px;
        font-weight: 600;
    }
    .single-activity__name span {
        font-size: 14px;
    }
    .dashboard-active-panel {
        border: 1px solid #dfe9f3;
        border-radius: 8px;
        padding: 20px;
        display: flex;
        justify-content: center;
        align-items: flex-end;
    }   
    .error_text {
        font-size: 12px;
        color: #F44336;
    } 
</style>